import { EModalSectionMode } from '@constants';
import { Form } from 'antd';
import { useEffect } from 'react';

import { ModalSectionProps, SectionFormValues } from './types';

export const useModalSection = ({
  mode,
  onSubmit,
  initialValues,
  open,
  onClose
}: ModalSectionProps) => {
  const isEditMode = mode === EModalSectionMode.EDIT;
  const [form] = Form.useForm<SectionFormValues>();

  const name = Form.useWatch('name', form);
  const description = Form.useWatch('description', form);

  const hasChanges = isEditMode
    ? name !== initialValues?.name || description !== initialValues?.description
    : true;

  const isFormValid = name && name.trim().length > 0 && hasChanges;

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleFinish = () => {
    const values = form.getFieldsValue();

    onSubmit(values, { onSuccess: handleClose });
  };

  useEffect(() => {
    if (open && initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [open, initialValues, form]);

  return {
    form,
    isFormValid,
    handleClose,
    handleFinish,
    isEditMode
  };
};
